import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Sparkles, ArrowRight } from "lucide-react";

const inr = (v) => "₹" + Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export default function RemedyCrossSell({ keywords = [] }) {
  const [product, setProduct] = useState(null);

  useEffect(() => {
    let cancel = false;
    api.get("/content/remedies").then(({ data }) => {
      if (cancel) return;
      const kw = keywords.map((k) => k.toLowerCase());
      const match = data.find((p) => kw.some((k) => (p.title || "").toLowerCase().includes(k)));
      setProduct(match || null);
    }).catch(() => {});
    return () => { cancel = true; };
  }, [keywords]);

  if (!product) return null;
  const discount = product.regular_price && product.offer_price && product.regular_price > product.offer_price
    ? Math.round((1 - product.offer_price / product.regular_price) * 100) : 0;

  return (
    <div className="rounded-2xl border border-amber-400/25 bg-gradient-to-br from-amber-400/[0.08] to-[#0C1017] p-6 flex flex-col md:flex-row md:items-center justify-between gap-5" data-testid="remedy-cross-sell">
      <div className="flex items-start gap-4">
        <span className="grid place-items-center h-12 w-12 rounded-full bg-amber-400/15 text-amber-300 shrink-0"><Sparkles strokeWidth={1.5} /></span>
        <div>
          <p className="text-[11px] uppercase tracking-[0.2em] text-amber-300 mb-1">Recommended remedy</p>
          <h3 className="text-lg text-slate-100" style={{ fontFamily: "Outfit, sans-serif" }}>{product.title}</h3>
          <p className="text-xs text-slate-400 mt-1 line-clamp-2 max-w-md">{product.description}</p>
          <div className="flex items-end gap-2 mt-2">
            <span className="text-xl font-bold text-amber-300" style={{ fontFamily: "Outfit, sans-serif" }}>{inr(product.offer_price)}</span>
            {discount > 0 && <span className="text-xs text-slate-500 line-through mb-0.5">{inr(product.regular_price)}</span>}
            {discount > 0 && <span className="text-[10px] px-2 py-0.5 rounded-full bg-amber-400/15 text-amber-300 border border-amber-400/25 mb-0.5">{discount}% off</span>}
          </div>
        </div>
      </div>
      <Link to="/remedies" className="shrink-0">
        <Button className="rounded-full bg-amber-400/15 text-amber-300 border border-amber-400/30 hover:bg-amber-400/25 whitespace-nowrap" data-testid="cross-sell-cta">
          Explore remedy <ArrowRight size={15} strokeWidth={1.5} />
        </Button>
      </Link>
    </div>
  );
}
